import React from 'react';

import { Component as PayPalLoader } from '../../../src/components/PayPalLoader';
import { useMatchMedia } from '../../styles/useMatchMedia';
import { useLDNewShoppingBagUX } from '../../utils/LD/useNewShoppingBagUX';
import { Component as Bounceback } from '../Bounceback';
import { Component as NewPricingSkinnyBanner } from '../NewPricingSkinnyBanner';
import ProgressLoader from '../ProgressLoader/ProgressLoaderContainer';
import { Component as StyleContext } from '../StyleContext';
import ToastMessages from '../ToastMessages/ToastMessages';

import { CartDrawerBasketItemList } from './CartDrawerBasketItemList';
import { CartDrawerFooter } from './CartDrawerFooter';
import { CartDrawerHeader } from './CartDrawerHeader';
import { CartDrawerInfluencerToastMessage } from './CartDrawerInfluencerToastMessage';
import { OldCartDrawerPromoProgressBarRenderer } from './CartDrawerPromoProgressBar';
import { CartDrawerBody, Content, Drawer } from './CartDrawerWrapper';
import { NewCartDrawerDesktopTabletRenderer } from './NewCartDrawerDesktopTabletRenderer';
import { NewCartDrawerMobileRenderer } from './NewCartDrawerMobileRenderer';

const NewCartDrawerRenderer = ({ collapsableFooter, expandedFooter }) => {
  const { isMobile } = useMatchMedia();

  if (isMobile) {
    return (
      <NewCartDrawerMobileRenderer
        collapsableFooter={collapsableFooter}
        expandedFooter={expandedFooter}
      />
    );
  }

  return (
    <NewCartDrawerDesktopTabletRenderer
      collapsableFooter={collapsableFooter}
      expandedFooter={expandedFooter}
    />
  );
};

// TODO: refactor to remove footer prop, aligning the approach with the rest of component
export const CartDrawerRenderer = ({
  footer,
  collapsableFooter,
  expandedFooter,
}) => {
  const shoppingBagFlagStatus = useLDNewShoppingBagUX();

  if (shoppingBagFlagStatus?.isControl) {
    return (
      <Drawer>
        <StyleContext context="cartDrawer">
          <ToastMessages data-autotag="mini-cart-toast-message" />
          <Content>
            <ProgressLoader overlay />
            <NewPricingSkinnyBanner />
            <CartDrawerHeader />
            <Bounceback shouldShowTerms={false} />
            <OldCartDrawerPromoProgressBarRenderer />
            <CartDrawerBody>
              <CartDrawerInfluencerToastMessage />
              <CartDrawerBasketItemList />
            </CartDrawerBody>
            <CartDrawerFooter footer={footer} />
          </Content>
        </StyleContext>
      </Drawer>
    );
  } else {
    return (
      <PayPalLoader>
        <NewCartDrawerRenderer
          collapsableFooter={collapsableFooter}
          expandedFooter={expandedFooter}
        />
      </PayPalLoader>
    );
  }
};
